import React from 'react';
import NewAuditionInfoSheet from './NewAuditionInfoSheet';
import ViewAuditionInfoSheet from './ViewAuditionInfoSheet';

interface IProps {
  match: any;
}

const AuditionInfoSheet: React.FC<IProps> = ({
  match
}) => {
  return Number(match.params.infoSheetId) ? (
    <ViewAuditionInfoSheet />
  ) : (
    <NewAuditionInfoSheet />
  );
};

export default AuditionInfoSheet;
